import { VolumeAggregateBy, VolumeTimeRange } from '@fullstory/proto/fs/services/dx-objects';
import { AppBackendRequestActions, fullstorySelectors } from '@fullstory/redux';
import { useXhrRequest } from '@fullstory/redux-util';
// NB(vasilios): Fixes "error TS2742: inferred type cannot be named without a reference"
// See https://github.com/aspect-build/rules_ts/issues/159 for more information.
import type {} from '@fullstory/redux-util/types';
import jstz from 'jstz';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

const timeRangeToAggregation = {
  [VolumeTimeRange.DAY_30]: VolumeAggregateBy.DAY,
  [VolumeTimeRange.DAY_7]: VolumeAggregateBy.DAY,
  [VolumeTimeRange.HOUR_72]: VolumeAggregateBy.HOUR,
};

type UseNamedElementDetailsViewArg = {
  namedElementId: string | undefined;
  timeRange?: VolumeTimeRange;
};

export function useGetNamedElementDetailsView({
  namedElementId,
  timeRange = VolumeTimeRange.DAY_30,
}: UseNamedElementDetailsViewArg) {
  const orgId = useSelector(fullstorySelectors.getOrgId);
  const timezone = jstz.determine().name();

  const request = useMemo(
    () =>
      namedElementId
        ? AppBackendRequestActions.getNamedElementDetailView({
            orgId,
            namedElementId,
            timeRange,
            volumeAggregateBy: timeRangeToAggregation[timeRange],
            timezone,
          })
        : null,
    [namedElementId, orgId, timeRange, timezone],
  );

  return useXhrRequest(request);
}
